import type { QuickSearchProviderConfig } from '@/lib/quick-search/types'

/**
 * Provider for Quick Search configurations.
 * Clients should configure this provider during app initialization.
 */
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class QuickSearchProvider {
  private static activeConfig: QuickSearchProviderConfig = null

  /**
   * Configure the quick search provider with a client's configuration.
   *
   * @param config - The quick search configuration for the client
   */
  static setConfig(config: QuickSearchProviderConfig) {
    this.activeConfig = config
  }

  /**
   * Get the active quick search configuration for a client.
   *
   * @returns The quick search configuration, or null if not configured
   */
  static getConfig(): QuickSearchProviderConfig {
    return this.activeConfig
  }

  /**
   * Check if the provider has been configured.
   *
   * @returns True if the provider has been configured, false otherwise
   */
  static isConfigured(): boolean {
    return this.activeConfig !== null
  }

  /**
   * Reset the provider configuration. Primarily used for testing.
   */
  static reset() {
    this.activeConfig = null
  }
}

export default QuickSearchProvider
